import { CATEGORY_TYPE } from '@square/dashboard-items-data/models/connect/category/data';
export function isRegularCategory(cat) {
  return cat?.categoryType === CATEGORY_TYPE.REGULAR_CATEGORY;
}
export function getItemsCategories(store, items) {
  const categoryIds = new Set();
  const itemCategoryMemberships = items.flatMap(item => item.item_data?.categories ?? []);
  itemCategoryMemberships.forEach(catMembership => {
    categoryIds.add(catMembership.id);
  });
  const catIdPromises = [...categoryIds].map(catId => store.findRecord('connect/category', catId));
  return Promise.all(catIdPromises);
}